FamilycardsImageLibrary.controller('browseDesignTemplatesController', ['$scope', '$http', function ($scope, $http) {

    /**
     * Array of categories, which contain templates
     * @type {Array}
     */
    $scope.templateCategories = [];
    $scope.infinitescroll = {busy: false};
    /** @type {boolean} Specify that there are no (more) results */
    $scope.noResults = false;
    /** @type {number} currentPage to fetch, 0 means nothing fetched yet */
    $scope.currentPage = 0;
    /** @type {string} The current types of templates that should be shown, 0 = all, 1 = private only, 2 = public only */
    $scope.showTemplateType = 'ALL';

    var pageUrl = '/api/editor/sjablonen?huilen=true';

    $scope.getImages = function getImages() {

        if ($scope.infinitescroll.busy || $scope.noResults === true) {
            // Already loading or has determined there are no (more) results
            return;
        }

        $scope.infinitescroll.busy = true;
        $scope.currentPage++;

        $http({
            method: 'GET',
            url: pageUrl + '&page=' + $scope.currentPage + "&visibility=" + $scope.showTemplateType
        }).success(function (response, status, headers, config) {

            // Add the templates to the existing data structure
            var templates = response.data;
            var lastCategoryIndex = $scope.templateCategories.length - 1;

            for (var i = 0; i < templates.length; i++) {
                var template = templates[i];

                // Check if this is in a different category
                if (lastCategoryIndex < 0 || template.category !== $scope.templateCategories[lastCategoryIndex].name) {
                    $scope.templateCategories.push({
                        name: template.category,
                        templates: [template]
                    });
                    lastCategoryIndex++;
                } else {
                    // Add to last category
                    $scope.templateCategories[lastCategoryIndex].templates.push(template);
                }
            }

            // Check if there's a next page
            if (!('next_page_url' in response) || response.next_page_url === null) {
                $scope.noResults = true;
            }

            $scope.infinitescroll.busy = false;

        }).error(function (data, status, headers, config) {
        });

    };

    $scope.$on('reloadImages', function (event) {
        $scope.templateCategories = [];
        $scope.currentPage = 0;
        $scope.noResults = false;
        $scope.getImages();
    });

    $scope.onFilterModified = function() {
        $scope.$emit('reloadImages');
    };

    $scope.$watch(function () {

        if ($scope.currentPage > 0) {
            return;
        }

        $scope.$emit('reloadImages');

    }, true);

}]);
